import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {CardActionIcon as RmwcCardActionIcon} from '@rmwc/card'
import '@rmwc/card/styles'
import '@rmwc/icon-button/styles'

const StyledRmwcCardActionIcon = styled(RmwcCardActionIcon)`
  .mdc-theme--on-primary &&&:not(:disabled) {
    color: var(--mdc-theme-on-primary, #fff);
  }
`

const CardActionIcon = ({children, ...otherProps}) => <StyledRmwcCardActionIcon {...otherProps}>{children}</StyledRmwcCardActionIcon>

CardActionIcon.propTypes = {
  children: PropTypes.any
}

export {CardActionIcon}
